import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { List } from 'semantic-ui-react';
import ValidationSpan from '@/components/errors/ValidationSpan';
import RoleListDescription from '../containers/RoleListDescription';

const RoleFieldListItem = ({
  code,
  category,
  value,
  type,
  isEditing,
  canEdit,
  validationError,
}) => (
  <>
    <List.Header className={clsx(validationError && 'aridhia-is-edit-mode-validation-highlight')}>
      <FormattedMessage id={`role.${type}.title`} />
      <ValidationSpan validationError={validationError} />
    </List.Header>
    {!isEditing && (
      <RoleListDescription
        code={code}
        category={category}
        value={value}
        isEditing={isEditing}
        canEdit={canEdit}
      />
    )}
  </>
);

export default RoleFieldListItem;
